import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled(Link)`
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  flex-grow: 1;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-decoration: none;
  box-shadow: ${({ theme }) => theme.shadow.vertical};

  @media ${({ theme }) => theme.devices.tablet} {
    min-width: 300px;
  }
`;

export const Picture = styled.picture`
  display: flex;
  justify-content: center;
  height: 100px;
  background-color: ${({ theme }) => theme.colors.white.normal};
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 10px;
`;

export const Info = styled.div`
  background-color: ${({ theme }) => theme.colors.white.normal};
  bottom: 0;
  flex-grow: 1;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
`;

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.mm};
  font-weight: 800;
  color: ${({ theme }) => theme.colors.gray.dark};
  font-family: ${({ theme }) => theme.fonts.inter};
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

export const Salary = styled.span`
  font-size: ${({ theme }) => theme.fontSize.mm};
  font-family: ${({ theme }) => theme.fonts.inter};
  background-color: ${({ theme }) => theme.colors.white.normal};
  font-weight: 600;
  flex-grow: 1;
  color: ${({ theme }) => theme.colors.green.normal};
  display: flex;
  flex-direction: column-reverse;
  padding-bottom: 10px;
  margin: 10px 10px;
`;

export const Location = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.gray.dark};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-family: ${({ theme }) => theme.fonts.inter};
`;

export const ViewCount = styled.div`
  background-color: ${({ theme }) => theme.colors.gray.dark};
  border: none;
  color: ${({ theme }) => theme.colors.white.normal};
  width: 100%;
  padding: 0;
  margin: 0;
  padding: 1px;
  font-weight: 600;
  letter-spacing: 1px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-family: ${({ theme }) => theme.fonts.inter};
`;

export const Views = styled.span`
  margin-left: 10px;
`;

export const Contacts = styled.span`
  float: right;
  margin-right: 10px;
`;

export const Content = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.white.normal};
`;
